module.exports = require("core-js/library/fn/object/define-properties");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/object/define-properties.js
// module id = 105
// module chunks = 92